const options = {
  5: "bg-neutral-600/5",
  10: "bg-neutral-600/10",
  25: "bg-neutral-600/25",
  50: "bg-neutral-600/50",
  75: "bg-neutral-600/75",
  90: "bg-neutral-600/90",
  100: "bg-neutral-600",
};

const from = {
  5: "from-neutral-600/5",
  10: "from-neutral-600/10",
  25: "from-neutral-600/25",
  50: "from-neutral-600/50",
  75: "from-neutral-600/75",
  90: "from-neutral-600/90",
  100: "from-neutral-600",
};

export default function getBackgroundNeutral600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
